import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Nullable } from "../../Types/Common";
import createServiceAsyncThunk from "./createServiceAsyncThunk";
import { Draft } from "immer";
import { ErrorOccured } from "../Constant";

// Define the shape of the generic state
export interface GenericState<T> {
  loading: boolean;
  error: Nullable<any>;
  data: Nullable<T>;
}

// Create the generic slice function
const createGenericSlice = <T, Args>(
  name: string,
  asyncThunk: ReturnType<typeof createServiceAsyncThunk<T, Args>>
) => {
  const initialState: GenericState<T> = {
    loading: false,
    data: null,
    error: null,
  };
  return createSlice({
    name,
    initialState,
    reducers: {
      // A common reducer to clear errors
      clearError: (state) => {
        state.error = null;
      },
      clearSuccessMessage: (state) => {
        state.data = null;
      },
      // Optionally add other common reducers if needed
    },
    extraReducers: (builder) => {
      builder.addCase(asyncThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      });
      builder.addCase(
        asyncThunk.fulfilled,
        (state, action: PayloadAction<T>) => {
          state.data = action.payload as Draft<T>;
          state.loading = false;
        }
      );
      builder.addCase(
        asyncThunk.rejected,
        (state, action: PayloadAction<any>) => {
          state.error = action.payload || ErrorOccured;
          state.loading = false;
        }
      );
    },
  });
};

export default createGenericSlice;
